import memoizeOne from 'react-utils/memoizeOne';
import { getProjectName } from '../../../common/utils';
export const getAcademyQueryParams = memoizeOne(() => {
  const appName = getProjectName();
  return {
    appName
  };
});